module.exports = __webpack_public_path__ + "img/010.bb5ee25c.jpg";